module.exports = __webpack_public_path__ + "img/potential.8005b8a9.svg";